import React, { useEffect, useMemo } from 'react';
import { useAppShell } from '../contexts/AppShellContext';
import { useProxyData } from '../contexts/ProxyDataContext';
import { useProxyWorkflowContext } from '../hooks/useProxyWorkflowContext';
import { buildProxyIntakeTasks, isProxyTaskException } from '../data/proxyWorkflowRegistry';
import { ProxyTaskTable } from '../components/proxy/ProxyTaskTable';
import { useProxyEscalation } from '../hooks/useProxyEscalation';

export function ProxyExceptionsPage() {
  const { setTopbar } = useAppShell();
  const { jobs } = useProxyData();
  const ctx = useProxyWorkflowContext();
  const { escalate } = useProxyEscalation();

  useEffect(() => {
    setTopbar('Proxy Exceptions', "Tasks that are themselves the issue: no contact on file, a bounced email, or material Fulfillment couldn't match to a job.");
  }, [setTopbar]);

  const rows = useMemo(() => {
    const tasks = buildProxyIntakeTasks(ctx);
    return tasks
      .map(task => ({ task, job: jobs.find(j => j.jobId === task.jobId)! }))
      .filter(r => r.job && isProxyTaskException(r.task, r.job));
  }, [ctx, jobs]);

  return (
    <div className="h-full overflow-auto px-6 py-6">
      <ProxyTaskTable
        rows={rows}
        emptyTitle="No exceptions"
        emptyBody="Every open task has a confident read and a known contact."
        showEscalate
        onEscalate={escalate}
      />
    </div>
  );
}
